import React, {FC, MouseEvent} from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import {withStyles} from '@material-ui/core';

import {StyledPopover} from '../../../../../../categorized-dropdown';
import LegendWithTooltip, {LegendWithTooltipProps} from './LegendWithTooltip';
import AutocompleteList from '../../../../../../game-select/AutocompleteList';

const StyledAutocompleteList = withStyles(theme => ({
    option: {
        padding: '0 !important',

        '&[data-focus="true"]': {
            backgroundColor: 'initial'
        },

        '& button': {
            padding: theme.spacing(2, 4)
        }
    }
}))(AutocompleteList);

export interface MoreLegendButtonProps {
    chipLabel: string;
    open: boolean;
    anchorEl?: HTMLElement;
    resultsLabel: string;
    placeholder: string;
    options: LegendWithTooltipProps[];
    title: string;
    onClose: (event: MouseEvent<HTMLElement>) => void;
}

const MoreLegendButton: FC<MoreLegendButtonProps> = ({
    chipLabel,
    onClose,
    open,
    anchorEl,
    resultsLabel,
    placeholder,
    options
}: MoreLegendButtonProps) => (
    <>
        <Chip label={chipLabel} size="small" onClick={onClose} />
        <StyledPopover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}>
            <Box mt={2}>
                <StyledAutocompleteList
                    resultsLabel={resultsLabel}
                    placeholder={placeholder}
                    options={options}
                    value={[]}
                    renderOption={props => <LegendWithTooltip {...props} />}
                />
            </Box>
        </StyledPopover>
    </>
);

export default MoreLegendButton;
